
import { Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface MobileMenuButtonProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

export const MobileMenuButton = ({ isOpen, onClick, className }: MobileMenuButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "fixed z-50 bottom-6 left-6 w-12 h-12 rounded-full bg-gradient-to-r from-emerald-600 to-sky-600 text-white shadow-lg md:hidden flex items-center justify-center transition-all duration-300",
        isOpen ? "rotate-90 scale-110" : "hover:shadow-emerald-500/25 hover:scale-105",
        className
      )}
      aria-label={isOpen ? "Close menu" : "Open menu"}
    >
      {isOpen ? (
        <X className="w-5 h-5" />
      ) : (
        <Menu className="w-5 h-5" />
      )}
    </button>
  );
};
